module.exports = __webpack_public_path__ + "static/media/hand.1d86c870.svg";